<template>
<div id="index-page" class="">
  <b-navbar type="light" variant="light-success">
    <b-navbar-brand href="#">
      <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
      {{ logoName }}
    </b-navbar-brand>
    <b-navbar-nav class="ml-auto" v-b-scrollspy>
      <b-nav-item href="#contact">ติดต่อเรา</b-nav-item>
      <b-button variant="outline-licm" class="my-2 my-sm-0 px-4" v-if="!dataReady" @click="loginUser">เข้าสู่ระบบ</b-button>
      <template v-if="dataReady">
        <b-nav-item :to="{ path: '/pod/OrderList' }" replace>รายการข้อมูลพรีออร์เดอร์</b-nav-item>
        <b-nav-item :to="{ path: '/User/Tracking' }" replace>รายการรหัสพัสดุ</b-nav-item>
        <b-nav-item> | ยินดีต้อนรับ {{ userData.firstName + " " + userData.lastName }}</b-nav-item>
        <b-button variant="outline-licm" class="my-2 my-sm-0 px-4" @click="logoutUser">ออกจากระบบ</b-button>
      </template>
    </b-navbar-nav>
  </b-navbar>

  <b-container fluid>
    <b-row class="bg-white d-none d-lg-block">
      <img :src="bannerImage" alt="img" width="1200px">
      <img :src="bannerTextImage" alt="Logo" width="40%" class="cover-img">
    </b-row>
    <b-row class="d-lg-none">
      <b-card
        overlay
        :img-src="require('@/assets/hero.png')"
        img-alt="LICM WELCOME"
        class="w-100 card-img-welcome"
      >
      </b-card>
    </b-row>
        <br>
        <br>


    <b-row>
      <b-col sm="10" class="mx-auto">
        <b-card class="text-center pic-shadow bor-licm">
          <div class="">
            <h1>เรทราคาการขนส่งจากจีน</h1>
          </div>
          <b-row>
            <b-col md="6">
              <!-- <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/new_price_20032023%2FnewPrice%20(4).jpg?alt=media&token=d375bbfd-5930-490a-8b19-6490b90fdcae"></b-img-lazy> -->
              <b-img-lazy center rounded  class="w-100 my-2" :src="priceTrackImage"></b-img-lazy>
            </b-col>
            <b-col md="6">
              <b-img-lazy center rounded  class="w-100 my-2" :src="priceNbImage"></b-img-lazy>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="text-center pic-shadow bor-licm my-3">
          <div class="">
            <h1>เรทราคาสมาชิก VIP</h1>
          </div>
          <b-row>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2 zoom" :src="priceVip1Image"></b-img-lazy>
            </b-col>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2 zoom" :src="priceVip2Image"></b-img-lazy>
            </b-col>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2 zoom" :src="priceVip3Image"></b-img-lazy>
            </b-col>
          </b-row>
        </b-card>

        <b-card class="text-center pic-shadow" style="border: 0px; background-color: transparent;">
          <b-row>
            <b-col md="4">
              <!-- <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/price1.jpg?alt=media&token=5ac875b1-6b4c-4c28-a5fa-0a9a76b5e14c"></b-img-lazy> -->
              <b-img-lazy center style="max-width: 900px;" class="w-100 my-5 bor-licm" :src="processLicmImage"></b-img-lazy>
            </b-col>
            <b-col md="4">
              <!-- <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/price2.jpg?alt=media&token=59eb8c9b-240a-4df7-9559-19e1b6d7e368"></b-img-lazy> -->
            <b-img-lazy center style="max-width: 940px;" class="w-100 my-5 bor-licm" :src="timingLicmImage"></b-img-lazy>
            </b-col>
            <b-col md="4">
              <!-- <b-img-lazy center rounded  class="w-100 my-2" src="https://firebasestorage.googleapis.com/v0/b/trackingpreorder.appspot.com/o/price2.jpg?alt=media&token=59eb8c9b-240a-4df7-9559-19e1b6d7e368"></b-img-lazy> -->
            <b-img-lazy center style="max-width: 940px;" class="w-100 my-5 bor-licm" :src="calNewLICMImage"></b-img-lazy>
            </b-col>
          </b-row>
        </b-card>


        <b-card class="text-center pic-shadow bor-licm">
          <div class="">
            <h1>บริการของเรา</h1>
          </div>
          <b-row>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2" :src="serviceTranChaiImage"></b-img-lazy>
            </b-col>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2" :src="servicePreOrderImage"></b-img-lazy>
            </b-col>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2" :src="serviceMotorImage"></b-img-lazy>
            </b-col>
            <b-col md="4">
              
            </b-col>
            <b-col md="4">
              <b-img-lazy center rounded  class="w-100 my-2" :src="promoteImage"></b-img-lazy>
            </b-col>
            <b-col md="4">

            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row id="contact">
      <b-card
        overlay
        :img-src="require('@/assets/footer.jpg')"
        img-alt="LICM WELCOME"
        class="w-100 border-0 mt-5"
      >
      </b-card>
    </b-row>

  </b-container>
</div>
</template>

<script>

export default {
  name: 'Index',
  beforeCreate () {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
    // document.body.className = 'login';
  },
  created () {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
  },
  async mounted () {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    // this.$session.destroy()
    // localStorage.removeItem('memberData')
    this.getDataUser()
  },
  data () {
    return {
      msg: 'Welcome LICM',
      dataReady: false,
      processLicmImage: require('@/assets/ProcessLicm.jpg'),
      timingLicmImage: require('@/assets/timingLicm.jpg'),
      calNewLICMImage: require('@/assets/calLicm.jpg'),
      bannerImage: require('@/assets/img/AdobeStock_480886056_2.png'),
      bannerTextImage: require('@/assets/img/GroupTEXT.png'),
      priceTrackImage: require('@/assets/img/licm_track_0424.jpg'),
      priceNbImage: require('@/assets/img/pricenb.jpg'),
      priceVip1Image: require('@/assets/img/newPrice_1.jpg'),
      priceVip2Image: require('@/assets/img/newPrice_2.jpg'),
      priceVip3Image: require('@/assets/img/newPrice_3.jpg'),
      serviceTranChaiImage: require('@/assets/img/tranChai.jpg'),
      servicePreOrderImage: require('@/assets/img/PREordLicm.jpg'),
      serviceMotorImage: require('@/assets/img/MOTRNew.jpg'),
      promoteImage: require('@/assets/img/promote001.jpeg'),
      userData: {
        userName: '',
        userCode: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: '',
      },
    }
  },
  methods: {
    getDataUser () {
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser
        this.dataReady = true
      } else {
        this.dataReady = false;
      }
    },
    logoutUser () {
      this.$session.destroy()
      this.$router.go(this.$router.currentRoute)
    },
    loginUser () {
      this.$router.push('/Login')
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#index-page {
  font-family: 'Kanit', sans-serif !important;
}

.form-login{
  margin-top: 60px;
}
label{
  font-weight: 600;
}

.btn-outline-licm {
    color: #1a5231;
    background-color: #fff;
    border-color: #1a5231;
    font-weight: 400;
}

.btn-outline-licm:hover {
    color: #fff;
    background-color: #1a5231;
    border-color: #1a5231;
}

.card-img-welcome img{
  max-width: 1000px;
}

img.cover-img {
  position: absolute;
  bottom: 40%;
  right: 10%;
}

.pic-shadow img {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.pic-shadow div.row div:hover {
  z-index: 100;
}

img.zoom {
  transition: transform .2s;
}

img.zoom:hover {
  -ms-transform: scale(1.5);
  -webkit-transform: scale(1.5);
  transform: scale(1.5);
}

.bor-licm {
  border: 5px #245c3b solid;
  /* border: 5px #FF7F63 solid; */
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue